import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            最新文章
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            持续更新优质内容，让你的耳朵永远不寂寞
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return <ArticleCard key={article.slug} article={article} category={cat} />;
          })}
        </div>
      </div>
    </section>
  );
}